import { render, staticRenderFns } from "./editDept.vue?vue&type=template&id=4d734e02&"
import script from "./editDept.vue?vue&type=script&lang=js&"
export * from "./editDept.vue?vue&type=script&lang=js&"
import style0 from "./editDept.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports